import useLocalization from '../../../Localization';
import React from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import Event2Listing from '../../CommonComponents/EventListing2.0';
import {Col, Row} from 'antd';
import PastEventsListing from '../../CommonComponents/PastEventsListing';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';

const WebinarsComponent = () => {
  const {ApplicationString} = useLocalization();
  return (
    <Row gutter={[0, 26]}>
      <Col span={24}>
        <div className='eventTypesStaticPageCard'>
          <SponsorOptionPageHeroText
            title={
              <span className='eventTypesStaticPageCardHeading'>
                {ApplicationString['userWebinarsComponent.heading']}
              </span>
            }
          />
          <SectionLayout>
            <p>{ApplicationString['userWebinarsComponent.p1']}</p>
            <br />
            <p>
              {ApplicationString['userWebinarsComponent.p2']}{' '}
              <a
                href='/'
                target='_blank'
                rel='noopener noreferrer'
                onClick={() => {
                  window.open('/');
                }}>
                click here
              </a>
            </p>
          </SectionLayout>
        </div>
      </Col>
    </Row>
  );
};

export default WebinarsComponent;
